<mwe-basic-card cardTitle="approval.title" [headingNodeType]="headlineNodeType()">
  @for (item of items(); track $index) {
    <mwe-approval-form-item [item]="item" [isApprovalFirmDirty]="isDirty()" />
    @if (!$last) {
      <hr />
    }
  }
</mwe-basic-card>
